import { ChevronRight, ChevronLeft, Close, Search } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import ChatAvatar from "./ChatAvatar";
import { chatListTime, chatPreview, chatTitle } from "../lib/presentation";

/** Frontend-style list retaining admin booth discovery and existing chat IDs. */
export default function ChatContactList({ contacts, selected, query, onQuery, onSelect,
  loading, opening, compact, onToggleCompact, onClose }) {
  return <>
    <div className="dk-chat-list-toolbar">
      <button type="button" className="dk-chat-icon dk-chat-collapse" onClick={onToggleCompact}
        aria-label={compact ? "بازکردن فهرست گفتگوها" : "جمع‌کردن فهرست گفتگوها"}>
        {compact ? <ChevronRight /> : <ChevronLeft />}
      </button>
      <label className="dk-chat-search">
        <Search fontSize="small" aria-hidden="true" />
        <input aria-label="جستجوی غرفه" placeholder="search booth ..." value={query}
          onChange={(event) => onQuery(event.target.value)} />
      </label>
      <button type="button" className="dk-chat-icon dk-chat-close-list" onClick={onClose}
        aria-label="بستن فهرست گفتگوها"><Close /></button>
    </div>
    <div className="dk-chat-contact-scroll">
      {loading ? [1, 2, 3, 4].map((key) => <Skeleton key={key} variant="rounded" height={74} />) :
        <ul className="dk-chat-contacts">
          {contacts.map((contact) => {
            const active = selected?.key === contact.key || Boolean(selected?.id && Number(selected.id) === Number(contact.id));
            const unread = Number(contact.unreadCount || 0);
            return <li key={contact.key}>
              <button type="button" className="dk-chat-contact" aria-current={active ? "true" : undefined}
                aria-label={chatTitle(contact)} disabled={!contact.canChat || opening}
                onClick={() => onSelect(contact)} data-booth-id={contact.boothId} data-chat-id={contact.id || ""}
                title={!contact.canChat ? "صاحب غرفه مشخص نیست یا غرفه متعلق به خود شماست" : chatTitle(contact)}>
                <ChatAvatar chat={contact} />
                <span className="dk-chat-contact-copy">
                  <span className="dk-chat-contact-top"><strong>{chatTitle(contact)}</strong>
                    <time>{chatListTime(contact.lastMessageDate || contact.createdAt)}</time></span>
                  <span className="dk-chat-contact-bottom"><span>{chatPreview(contact)}</span>
                    {unread > 0 && <span className="dk-chat-unread" aria-label={`${unread} پیام خوانده‌نشده`}>{unread > 99 ? "۹۹+" : unread}</span>}
                  </span>
                </span>
              </button>
            </li>;
          })}
          {!contacts.length && <li className="dk-chat-empty">موردی پیدا نشد</li>}
        </ul>}
    </div>
  </>;
}
